(() => {
	/** @type {HTMLAnchorElement[]} */
	const linkIcons = Array.from(document.querySelectorAll("section[id] a.js-link"));

	for (const linkIcon of linkIcons) {
		const id = linkIcon.closest("section[id]").id;
		const url = `${window.location.origin}${window.location.pathname}#${id}`;
		linkIcon.href = url;
	}
})();

// Swiper: Browser Source and Dock Setup
(() => {
	const els = [
		".browser-slideshow",
		".dock-slideshow",
	];

	for (const el of els) {
		new Swiper(`${el}`, {
			// Optional parameters
			direction: "horizontal",

			// Navigation arrows
			navigation: {
				nextEl: `${el} .swiper-button-next`,
				prevEl: `${el} .swiper-button-prev`,
			},

			pagination: {
				el: `${el} .swiper-pagination`,
				clickable: true,
			},
		});
	}
})();